var _defs, _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSevanova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_10",
    "data-name": "Calque 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 263 790.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e6eaed;}.cls-3{fill:#f7f7f7;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#ea5b0c;}.cls-6{fill:#1d1d1b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1537 1313 1537 1783.49 1420 1858.41 1420 1387.92 1537 1313"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sevanova") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1615,2013V1235l-263,149,5,519,227-134,1-492,10-7.8V2020C1595,2027,1615,2030,1615,2013Z",
    transform: "translate(-1352 -1235)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233 42 0.22 172 5 668 232 534 233 42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "127.32 199.77 147.63 207.07 167.94 173.76 147.63 166.46 167.94 133.14 147.63 125.84 127.32 159.15 127.32 159.15 107.01 151.85 86.71 185.16 107.01 192.46 86.71 225.78 107.01 233.08 127.32 199.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "137.6 162.88 167.94 173.76 147.63 207.07 127.32 199.77 137.6 182.9 137.6 162.88"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1471.27,1473.26c-2.17,7.38-3.11,13-3.11,15.93s.65,4.5,2.17,3.53c2.24-1.44,2.45-5.55,3.32-10.08,1.66-9.15,4.34-15,10.76-19.1,7.66-4.9,12-1.75,12,7.93a68.65,68.65,0,0,1-2.52,16.72l-8.67,3.31c1.59-6.29,2.45-11.47,2.45-14.36,0-2.68-.86-3.64-2.45-2.62-2.24,1.43-2.31,4.59-3.32,9.93-1.52,8.41-3.9,14.63-10.77,19-7.95,5.09-11.84,1.3-11.84-8.31a69.15,69.15,0,0,1,3.1-18.46Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1480.73,1537.27a42.17,42.17,0,0,1-6.65,3.6v-23.48a17.53,17.53,0,0,0-5.27,12.12,47.23,47.23,0,0,0,1.73,11.46l-8.52,7a32.16,32.16,0,0,1-2.74-12.54c0-13.07,7.94-25.39,18.63-32.23,11.27-7.22,18.57-4.09,18.57,6.53,0,10.19-6.29,21.43-15.75,27.57m.51-24.89v14.45c3.9-2.71,6.35-7,6.35-11.08s-2.38-5.12-6.35-3.37",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.36 330.62 143.39 293.01 143.39 305.65 122.3 327.61 143.39 322.56 143.39 335.2 108.36 342.46 108.36 330.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1494.74,1609.18l-34.38,22v-11.78l2.38-1.52c-2.16-1.36-3.46-3.63-3.46-7.89,0-8.45,6.57-20.83,18.78-28.64,11-6.79,18.42-5.08,18.42,5.75,0,6.65-.51,10.66-1.74,22.06m-16.9-16.33c-5.27,3.37-8.88,8.93-8.88,13.56a5.82,5.82,0,0,0,3,5.57l14.66-9.39c.22-2.52.37-4.78.37-7.31,0-5.71-3.84-5.86-9.18-2.43",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1483,1662l-22.61,14.47v-11.7l19.14-12.26c4.41-2.82,6.36-6.67,6.36-10,0-1.88-.15-4.1-.36-6.92l-25.14,16.1V1640l34.38-22a172.82,172.82,0,0,1,1.74,21.06c0,8.6-5.42,17.78-13.51,23",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1478.06,1711.09c-11.35,7.26-18.93,4-18.93-7.75s7.58-24.72,18.93-32,18.71-3.82,18.71,7.88-7.45,24.63-18.71,31.85m0-11.2c5.2-3.33,8.67-9.16,8.67-14.22s-3.47-6.45-8.67-3.12-8.89,9.3-8.89,14.36,3.54,6.4,8.89,3",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.36 502.65 143.39 465.05 143.39 477.69 122.3 499.65 143.39 494.6 143.39 507.23 108.36 514.5 108.36 502.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1494.74,1781.22l-34.38,22v-11.78l2.38-1.52c-2.16-1.36-3.46-3.63-3.46-7.9,0-8.45,6.57-20.82,18.78-28.64,11-6.78,18.42-5.07,18.42,5.76,0,6.65-.51,10.66-1.74,22.06m-16.9-16.34c-5.27,3.38-8.88,8.94-8.88,13.57a5.83,5.83,0,0,0,3,5.57l14.66-9.39c.22-2.53.37-4.79.37-7.31,0-5.71-3.84-5.86-9.18-2.44",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1447.57,1657.38l-8.37,5.36v-2.47l.6-.39a2.2,2.2,0,0,1-.87-2c0-2.37,1.76-5.22,4.57-7s4.48-1.3,4.48,1.4a37.1,37.1,0,0,1-.41,5.12m-4.14-4.05A4.87,4.87,0,0,0,1441,1657a1.69,1.69,0,0,0,.84,1.61l4-2.56c.05-.6.11-1.28.11-2.06,0-1.65-1.09-1.54-2.51-.63",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1447.57,1668.09l-8.21,5.26c-2.76,1.76-4.71,1.36-4.71-2a17.49,17.49,0,0,1,.51-3.37l2-.88a23.57,23.57,0,0,0-.34,2.79c0,1.62.85,2,2.38,1a19.56,19.56,0,0,1-.11-2.47c0-2.38,1.76-5.24,4.41-6.93s4.48-1.32,4.48,1.4a39.66,39.66,0,0,1-.41,5.11m-4.14-4a4.77,4.77,0,0,0-2.28,3.54,10.49,10.49,0,0,0,.15,2.06l4.53-2.9c.05-.61.11-1.28.11-2.06,0-1.67-1.09-1.55-2.51-.64",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.28,1680.43a11.18,11.18,0,0,1-1.72,1v-6a4.78,4.78,0,0,0-1.48,3.37,12.08,12.08,0,0,0,.45,2.73l-1.94,1.58a7.92,7.92,0,0,1-.66-3,9.6,9.6,0,0,1,4.54-7.84c2.75-1.77,4.53-1,4.53,1.59a8.41,8.41,0,0,1-3.72,6.59m0-6.24v4a4,4,0,0,0,1.76-3.09c0-1.1-.7-1.38-1.76-.93",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.71,1690.47l-5.51,3.52v-2.47l4.78-3.06a3.61,3.61,0,0,0,1.76-2.83,18.67,18.67,0,0,0-.12-1.93l-6.42,4.11v-2.47l8.37-5.36a36,36,0,0,1,.41,4.8,7.09,7.09,0,0,1-3.27,5.69",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1445.65,1698.93a16.7,16.7,0,0,0,.36-2.63c0-1.69-1-2-2.51-1.1a5.2,5.2,0,0,0-2.45,4.13,9.68,9.68,0,0,0,.37,2.32l-2,1.58a7.32,7.32,0,0,1-.54-2.72,9.78,9.78,0,0,1,4.59-7.75c2.79-1.79,4.55-.93,4.55,2a13.58,13.58,0,0,1-.48,3.28Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.28,1709.69a11.07,11.07,0,0,1-1.72.94v-6a4.78,4.78,0,0,0-1.48,3.36,12.06,12.06,0,0,0,.45,2.74l-1.94,1.58a7.92,7.92,0,0,1-.66-3,9.6,9.6,0,0,1,4.54-7.84c2.75-1.77,4.53-1,4.53,1.59a8.43,8.43,0,0,1-3.72,6.6m0-6.25v4a4,4,0,0,0,1.76-3.08c0-1.11-.7-1.39-1.76-.94",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1445.65,1721.41a16.7,16.7,0,0,0,.36-2.63c0-1.69-1-2-2.51-1.1a5.2,5.2,0,0,0-2.45,4.13,9.61,9.61,0,0,0,.37,2.32l-2,1.58a7.32,7.32,0,0,1-.54-2.72,9.78,9.78,0,0,1,4.59-7.75c2.79-1.79,4.55-.92,4.55,2a13.58,13.58,0,0,1-.48,3.28Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1445.56,1729c0-1,0-2-.1-3l-6.26,4v-2.47l8.23-5.27a29.13,29.13,0,0,1,.55,5.14Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1443.52,1740.47c-2.77,1.78-4.64,1-4.64-1.81a9.82,9.82,0,0,1,4.64-7.78c2.74-1.76,4.57-1,4.57,1.89a9.68,9.68,0,0,1-4.57,7.7m0-2.43a4.91,4.91,0,0,0,2.36-3.86c0-1.41-.94-1.76-2.36-.85a5,5,0,0,0-2.44,3.92c0,1.41,1,1.72,2.44.79",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1441.65,1743.32a14.26,14.26,0,0,0-.74,3.93c0,.85.19,1.33.65,1,.68-.43.77-1.68,1-2.9.37-2.19,1.09-3.63,2.56-4.57,1.8-1.15,2.84-.38,2.84,1.91a15.35,15.35,0,0,1-.64,4l-1.86.65a17.93,17.93,0,0,0,.59-3.49c0-.78-.29-1-.73-.76-.66.42-.72,1.36-1,2.77-.39,2.2-.95,3.55-2.55,4.58-2,1.26-2.86.24-2.86-2a14.93,14.93,0,0,1,.75-4.33Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1441.65,1751.94a14.26,14.26,0,0,0-.74,3.93c0,.85.19,1.33.65,1,.68-.43.77-1.68,1-2.9.37-2.19,1.09-3.63,2.56-4.57,1.8-1.15,2.84-.38,2.84,1.91a15.35,15.35,0,0,1-.64,4l-1.86.65a17.93,17.93,0,0,0,.59-3.49c0-.78-.29-1-.73-.76-.66.42-.72,1.36-1,2.77-.39,2.2-.95,3.55-2.55,4.57-2,1.27-2.86.25-2.86-2a15,15,0,0,1,.75-4.34Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.71,1777.21l-5.51,3.53v-2.47l4.78-3.07a3.3,3.3,0,0,0,1.76-2.9,7.16,7.16,0,0,0-.18-1.59,11.4,11.4,0,0,1-.94.69l-5.42,3.47v-2.47l4.78-3.06a3.29,3.29,0,0,0,1.76-2.89c0-.53,0-1.06-.09-1.58l-6.45,4.13v-2.47l8.33-5.33a23.77,23.77,0,0,1,.45,4.4,6.77,6.77,0,0,1-.5,2.58,10.86,10.86,0,0,1,.5,3.27,6.6,6.6,0,0,1-3.27,5.76",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.28,1787.72a11.07,11.07,0,0,1-1.72.94v-6a4.78,4.78,0,0,0-1.48,3.36,12.23,12.23,0,0,0,.45,2.74l-1.94,1.57a7.92,7.92,0,0,1-.66-3,9.6,9.6,0,0,1,4.54-7.84c2.75-1.76,4.53-1,4.53,1.6a8.43,8.43,0,0,1-3.72,6.59m0-6.25v4a4,4,0,0,0,1.76-3.08c0-1.1-.7-1.39-1.76-.94",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1439.32,1801.16a29.74,29.74,0,0,1-.32-4.8c0-2.28,1.57-5.09,4.54-7,2.66-1.69,4.44-1.37,4.44,1.6a16.5,16.5,0,0,1-.2,2.31l4-2.59v2.47Zm4.22-9.39a4.8,4.8,0,0,0-2.55,3.88c0,.29,0,.94.15,1.88l4.6-2.94a13.36,13.36,0,0,0,.2-2c0-1.81-1-1.72-2.4-.84",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1450.43,1795.91c.91-.57,1.58-.31,1.58.58a3.47,3.47,0,0,1-1.58,2.59c-.89.57-1.54.28-1.54-.59a3.41,3.41,0,0,1,1.54-2.58m-11.23,10v-2.47l8.51-5.45v2.47Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1447.57,1811.24l-8.37,5.36v-2.47l.6-.39a2.2,2.2,0,0,1-.87-2c0-2.37,1.76-5.22,4.57-7s4.48-1.31,4.48,1.39a37,37,0,0,1-.41,5.12m-4.14-4a4.87,4.87,0,0,0-2.44,3.64,1.69,1.69,0,0,0,.84,1.61l4-2.56c.05-.6.11-1.27.11-2.06,0-1.65-1.09-1.54-2.51-.63",
    transform: "translate(-1352 -1235)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevanova);
export default __webpack_public_path__ + "static/media/sevanova.3f76242963111f6cbcdd35934033fede.svg";
export { ForwardRef as ReactComponent };